/**
 * Sets up a $watch on the given property in scope, which calls the given callback function
 * (supplying the updated value) when the property changes.
 * If the callback fails, then the original value of the property is restored in such a way
 * that the callback doesn't get called again.
 */
export function watchWithUndo(scope: ng.IScope, property: string, callback: (val: any) => ng.IPromise<any>, objectEquality: boolean = false) {
  let appliedUndo = false;
  scope.$watch(property, (newVal: any, oldVal: any) => {
    if (newVal === oldVal) return;
    if (appliedUndo) {
      appliedUndo = false;
      return;
    }
    const promise = callback(newVal);
    if (promise === undefined) {
      // some callbacks may return undefined (void) instead of a promise (TypeScript doesn't enforce this)
      return;
    }
    promise.catch(() => {
      setDeepAttribute(scope, property, oldVal);
      appliedUndo = true;
    });
  }, objectEquality);
}

/**
 * Traverses the object by following the path specified in the property string (attribute names separated by dots)
 * e.g. property 'foo.bar.baz' is equivalent to object.foo.bar.baz or object['foo']['bar']['baz'].
 * Assumes that the property path is valid.
 */
function setDeepAttribute(object: any, property: string, value: any) {
  const path = property.split('.');
  let v = object;
  while (path.length > 1) {
    v = v[path.shift()];
  }
  v[path[0]] = value;
}
